export default __webpack_public_path__ + "static/media/shape-7.04e4d160.png";